import React, { Component } from 'react';
import { connect } from 'react-redux';
import { approveIssue } from 'actions/issueActions';
import Loading from 'components/Loading/Loading';

import IssueAppointmentSummary from '../../IssueAppointmentSummary';

import './style.css';

class ApproveIssue extends Component {
  componentWillMount() {
    const { id, secret } = this.props.routeParams;
    this.props.approveIssue(id, secret);
  }

  render() {
    return (
      <div className="ApproveIssue d-flex justify-content-center">
        <div className="card mb-4 mt-4">
          {(this.props.issueApproval.status === 'LOADING' ||
            this.props.issueApproval.status === null) && <Loading />}

          {this.props.issueApproval.status === 'SUCCESS' &&
            this.props.issueApproval.approved === 1 && (
              <div>
                <div className="title mb-4">Approved</div>
                <p>{this.props.issueApproval.message}</p>
              </div>
          )}

          {this.props.issueApproval.status === 'SUCCESS' &&
            this.props.issueApproval.approved === 0 && (
              <div>
                <div className="title mb-4">Sorry</div>
                <p>{this.props.issueApproval.message}</p>
              </div>
          )}

          {this.props.issueApproval.status === 'FAIL' && (
            <div>
              <div className="title error mb-4">Error</div>
              <p>
                {this.props.issueApproval.error.message || 'An unexpected problem was experienced'}
              </p>
            </div>
          )}

          {this.props.issueApproval.appointment && (
            <IssueAppointmentSummary
              issue={this.props.issueApproval.issue}
              appointment={this.props.issueApproval.appointment}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueApproval: state.issues
  };
}

export default connect(
  mapStateToProps,
  { approveIssue }
)(ApproveIssue);



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/routes/ApproveIssue/index.js